<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
      <div slot="isAuthState" slot-scope="prop">
        <el-checkbox
          label="待审核"
          name="type"
          v-model="prop.form.isAuthState"
        />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        authStateInOptions: [],
        vehicleGpsOptions: [],
        vehicleStateOptions: [],
        form: [
          {
            label: '',
            value: 'authStateIn',
            type: 'radio',
            default: '-1',
            class: 'especial-radio-group',
            normalFormNotCount: true,
            onChangeRadio: () => {
              this.$refs.searchBox.sub();
            },
          },
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          {
            label: '司机姓名',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入车司机姓名',
          },
          {
            label: '司机手机',
            value: 'mobilePhone',
            type: 'input',
            placeholder: '请输入车司机手机',
          },
          {
            label: '归属车队',
            value: 'tenantName',
            type: 'input',
            placeholder: '请输入归属车队',
          },
          {
            label: '车队手机',
            value: 'linkPhone',
            type: 'input',
            placeholder: '请输入车队手机',
          },
          // {
          //   label: '审核状态',
          //   value: 'isAuthState',
          //   default: false,
          //   slot: true,
          //   placeholder: '请选择审核状态',
          // },
          {
            label: '定位类型',
            value: 'vehicleGps',
            type: 'select',
            default: '-1',
            placeholder: '请选择定位类型',
          },
          {
            label: '定位日期',
            value: 'bdDate',
            type: 'date',
            placeholder: '请输入定位日期',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '使用状态',
            value: 'vehicleState',
            type: 'select',
            default: '-1',
            placeholder: '请选择使用状态',
          },
        ],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      // 定位日期
      if (searchBoxData.bdDate && searchBoxData.bdDate.length > 0) {
        searchBoxData.bdEffectDate = this.formatDate(searchBoxData.bdDate[0]);
        searchBoxData.bdInvalidDate = this.formatDate(searchBoxData.bdDate[1]);
        delete searchBoxData.bdDate;
      }
      searchBoxData.vehicleClass = '3';
      searchBoxData.shareFlgIn = '-1';
      searchBoxData.isAuth = searchBoxData.isAuthState ? '1' : '-1';
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'TENANT_VEHICLE_REL.AUTHSTATE,VEHICLE_LENGTH,VEHICLE_STATUS,CUSTOMER_AUTH_STATE,VEHICLE_STATUS_SUBTYPE,VEHICLE_GPS_TYPE,VEHICLE_STATE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.authStateInOptions = [
      { label: '全部', value: '-1' },
      ...safeEnum(0),
    ];
    this.searchBoxData.vehicleGpsOptions = [
      { label: '全部', value: '-1' },
      ...safeEnum(5),
    ];
    this.searchBoxData.vehicleStateOptions = [
      { label: '全部', value: '-1' },
      ...safeEnum(6),
    ];
  },
};
</script>
<style lang="scss" scoped>
</style>
